var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHublotLogoUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 40,
    viewBox: "0 0 153 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7095 0.543207H21.7485C21.7485 3.5174 20.6048 5.33376 17.4798 6.7718V0.543207H14.5001V7.86828C13.7663 8.09082 12.9684 8.30844 12.0991 8.52476H12.0971C11.4445 8.68341 10.8158 8.84955 10.2086 9.02337V0.543207H7.22898V10.0293C2.64085 11.8682 0 14.6049 0 19.4758H2.96109C2.96109 16.5018 4.10428 14.6856 7.22898 13.2473V19.4758H10.2086V12.1509C10.9428 11.9284 11.7408 11.7103 12.6104 11.4938H12.6126C13.2647 11.3353 13.8933 11.1697 14.5001 10.9958V19.4758H17.4798V9.99012C22.0687 8.15106 24.7095 5.41429 24.7095 0.543207Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8105 0.538511V19.4761H39.4904V11.466H48.9531V19.4761H52.6065V0.541702H48.9531V7.59213H39.4904V0.538511H35.8105Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.604 0.543152V10.4238C71.604 13.2948 71.3106 16.3399 66.6397 16.3399C61.9684 16.3399 61.6368 13.3603 61.6368 10.4238V0.543152H57.9757V10.6587C57.9757 15.1757 59.2286 20.0001 66.6397 20.0001C74.0509 20.0001 75.2968 15.1057 75.2968 10.6587V0.543152H71.604Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.197 0.541737V19.4692H114.877V15.6394H105.875V0.541737H102.197Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.085 16.2528C122.509 16.2528 119.708 13.4844 119.708 9.95007C119.708 6.41625 122.509 3.64766 126.085 3.64766C129.661 3.64766 132.464 6.41625 132.464 9.95007C132.464 13.4844 129.661 16.2528 126.085 16.2528ZM126.086 0.00103188C120.441 0.00103188 116.017 4.37253 116.017 9.95167C116.017 15.5294 120.441 19.8983 126.086 19.8983C131.731 19.8983 136.154 15.5294 136.154 9.95167C136.154 4.37253 131.731 0.00103188 126.086 0.00103188Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.652 0.541931V4.39355H143.557V19.4733H147.24V4.39355H153V0.541931H137.652Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2381 16.0183H83.8521L83.8509 11.2634H90.2596C92.1581 11.2634 92.9812 12.0095 92.9812 13.7081C92.9812 14.9807 92.4649 16.0183 90.2381 16.0183ZM89.6699 4.01089C91.7186 4.01089 92.3497 4.76021 92.3497 6.00606C92.3497 7.25285 91.8018 8.14034 89.7466 8.14034L83.8509 8.14226V4.01089H89.6699ZM94.5356 9.5461C95.6728 8.65158 96.3217 7.34917 96.3217 5.7715C96.3217 4.19862 95.6902 0.541767 89.8517 0.541767H80.197V19.4733H90.4641C94.5977 19.4733 96.9711 17.3709 96.9711 13.7129C96.9711 11.9313 96.1273 10.5045 94.5356 9.5461Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63.0001,
    y: 38.0001,
    width: 27,
    height: 2,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHublotLogoUnderline);
export default __webpack_public_path__ + "static/media/hublot-logo-underline.ac9ad111726444cf0dba2afff1290e97.svg";
export { ForwardRef as ReactComponent };